// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ArrowDiagonalUpIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ArrowDiagonalUp/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.707 5.636h5.657m0 0v5.657m0-5.657L5.636 18.364"
}));
export default ArrowDiagonalUpIcon;